var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal',{attrs:{"id":"demo-modal","data":{title:'WELCOME!', body: 'We have some new features we would like to introduce to you.',
            cancel: 'No thanks.', accept: 'Show me!'}},on:{"accept":_vm.startTour}}),_c('modal',{attrs:{"id":"demo-done","data":{title:'Need Extra Help?', body:
          'If your see the pulsing dot, click it to get some extra help.', html:
          '<div class=introjs-hint><div class=introjs-hint-dot></div><div class=introjs-hint-pulse></div></div></div>',
          accept: 'Got it!'}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }